// The latitude must be a number between -90 and 90 and the longitude between -180 and 180.
export const validateCoordinates = ({ lat, lng }: { lat?: number; lng?: number }) => {
  return lat && lng && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
};
